export const CREDIT_CARD_DESC_MAP = {
  VISA: '001',
  MasterCard: '002',
  AmericanExpress: '003',
  DiscoverCard: '004',
  JCB: '007',
  'Abercrombie & Fitch': 'anf',
  DinersClub: '005',
  CarteBancaire: '009',
  CarteBleue: '010',
  VisaDebit: '011',
  VisaElectron: '012',
  VisaCheckout: 'VISA_CHECKOUT',
  Maestro: '013',
  PayPal: 'ppl',
  Moneto: 'moneto',
  Ideal: 'ideal',
  WebMoney: 'webmoney',
  EPS: 'eps',
  Sofort: 'sofortuberweisung',
  Alipay: 'alipay',
  WECHATPAY: 'wechat',
  'klarnainvoice-DE': 'klarnainvoice-DE',
  'klarnaaccount-DE': 'klarnaaccount-DE',
  'klarnainvoice-NL': 'klarnainvoice-NL',
  'klarnaaccount-NL': 'klarnaaccount-NL',
  'klarnainvoice-FI': 'klarnainvoice-FI',
  'klarnaaccount-FI': 'klarnaaccount-FI',
  'klarnainvoice-AT': 'klarnainvoice-AT',
  agmo: 'agmo',
  ekonto: 'ekonto',
  przelewy24: 'przelewy24',
  payu: 'payu',
  sporopay: 'sporopay',
  trustpay: 'trustpay',
  euteller: 'euteller',
  cod: 'cod-jp',
  cashondelivery: 'cod-jp',
  Contactless: 'Store-JP',
  ANF: 'anf',
  'Gift Card': 'gift-card',
  Cash: 'cash',
  apple_pay: 'applepay',
  google_pay: 'google-pay',
};

// NOTE: this will get put into the resolver later
/**
 * get the payment icon name
 * @param {Object} payment
 * @returns {string}
 */
export function getPaymentIconName(payment) {
  if (!payment?.paymentName) return 'default';
  const { paymentName, cardType } = payment;
  const cardPaymentName = paymentName.toLowerCase();
  const cardPaymentType = cardType?.toLowerCase().replace(/\s+/g, '');
  const paymentCodeKey = (cardPaymentName === 'apple_pay' || cardPaymentName === 'google_pay')
    ? cardPaymentName
    : payment.cardType;

  if (cardPaymentName === 'klarna_v2') return 'klarna';

  if (paymentName === 'GIFT_CARD') return 'giftcard';

  return CREDIT_CARD_DESC_MAP[paymentCodeKey] || cardPaymentType;
}